module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-24.d95400cd.png";